<template>
    <div class="regionConfig">
        <custom-city-tree ref="customCityTree" @city-selected="handleCitySelect"
            url="/api/v1/manage/hitchRideRegionRule/list">
            <template>
                <el-button style="width: 100%;" @click="showModal" size="small">添加城市规则</el-button>
            </template>
        </custom-city-tree>

        <div class="regionConfig-content">
            <regionForm :rowData="{ ...selectCity }" @refresh="refresh"></regionForm>
        </div>

        <el-dialog title="添加城市规则" :visible.sync="visibleDialog" :before-close="handClose" width="500px" v-if="visibleDialog">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="适用城市" prop="cityCode">
                    <el-select v-model="ruleForm.cityCode" placeholder="请选择" filterable>
                        <el-option v-for="item in city" :key="item.adcode" :label="item.name"
                            :value="item.citycode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="接单总数" prop="maxOrderCount" class="ageFormItem">
                    <el-input v-model="ruleForm.maxOrderCount" v-input-filter="{ min: 2, max: 30, precision: 0 }">
                        <template slot="prepend">每日最多可接</template>
                        <template slot="append">单</template>
                    </el-input>
                </el-form-item>
                <el-form-item label=" 跨城订单" prop="maxCrossCityCount">
                    <el-input v-model="ruleForm.maxCrossCityCount" v-input-filter="{ min: 2, max: 30, precision: 0 }">
                        <template slot="prepend">每日最多可接</template>
                        <template slot="append">单</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handClose">取 消</el-button>
                <el-button type="primary" @click="sure" :loading="submitLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CustomCityTree from '@/page/business/rules/components/CustomCityTree.vue';
import regionForm from './regionForm.vue';
import { cityCodeJson } from "@/assets/js/city";
export default {
    components: { CustomCityTree, regionForm },
    data() {
        return {
            selectCity: {},
            cityList: cityCodeJson,
            visibleDialog: false,
            submitLoading: false,
            ruleForm: {
                cityCode: "",
                maxOrderCount: null,
                maxCrossCityCount: null,
            },
            rules: {
                cityCode: [
                    { required: true, message: "请选择城市", trigger: "change" },
                ],
                maxOrderCount: [{ required: true,message: "请输入接单总数", trigger: "blur" }],
                maxCrossCityCount: [
                    { required: true, message: "请输入跨城订单数", trigger: "blur" },
                    {
                        validator: (rule, value, callback) => { 
                            if (Number(value) > Number(this.ruleForm.maxOrderCount)) {
                                callback(new Error('不可大于接单总数'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
            },
        };
    },
    computed: {
        city() {
            let arr = []
            this.cityList.forEach((pre) => {
                if (pre.districts) {
                    pre.districts.forEach((item) => {
                        arr.push(item)
                    })
                }
            })
            return arr
        },
    },
    created() {

    },
    methods: {
        async showModal() {
            this.visibleDialog = true;
        },
        sure() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    this.submitLoading = true;
                    let params = this.$utils.deepCopyFn(this.ruleForm);
                    params.cityName = this.city.find(
                        (item) => item.citycode === params.cityCode
                    ).name;
                    params.provinceName = this.$utils.getCityName(this.cityList, params.cityCode, 'province')
                    delete params.age;
                    const url = "/api/v1/manage/hitchRideRegionRule/save";
                    const { code } = await this.$axios.post(url, params);
                    if (code === 1) {
                        this.$message.success("编辑成功");
                        this.handClose();
                    }
                    this.submitLoading = false;
                }
            });
        },
        handClose() {
            this.visibleDialog = false;
                this.ruleForm = {
                cityCode: "",
                cityName: "",
                maxOrderCount: null,
                maxCrossCityCount: null,
            };
            this.refresh()
        },
        handleCitySelect(node) {
            this.selectCity = node;
        },
        refresh() {
            this.$refs.customCityTree.getCityData(true);
        }
    }
};
</script>

<style lang="less" scoped>
.regionConfig {
    display: flex;

    &-content {
        padding: 16px;
        flex: 1;
        max-height: calc(100vh - 240px);
        overflow-y: auto;
    }

    /deep/ .el-input-group__append,
    .el-input-group__prepend {
        background-color: #F5F7FA !important;
    }
}
</style>